import { render, staticRenderFns } from "./ConversationList.vue?vue&type=template&id=764584b2&scoped=true&"
import script from "./ConversationList.vue?vue&type=script&lang=ts&"
export * from "./ConversationList.vue?vue&type=script&lang=ts&"
import style0 from "./ConversationList.vue?vue&type=style&index=0&id=764584b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764584b2",
  null
  
)

export default component.exports